module.exports = __webpack_public_path__ + "img/sheriff-logo-icon.72b1205c.png";